import { useMutation } from '@tanstack/react-query';
import apiClient from '../libs/apiClient';
import { UpdateSessionParams } from '../types/session';

const updateSession = async ({ sessionId, formIds, receptionNo }: UpdateSessionParams) => {
  const { status, data } = await apiClient.put(`/session/${sessionId}`, { formIds, receptionNo });
  return { status, data };
};

const useUpdateSession = () => {
  return useMutation({
    mutationFn: updateSession,
  });
};

export default useUpdateSession;
